var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dibu text-c"},[_vm._v("Copyright(c)"+_vm._s(_vm.当前年份)+" 网站备案号："),_c('a',{staticClass:"c-white",attrs:{"href":"https://beian.miit.gov.cn/","target":"_blank"}},[_vm._v("粤ICP备2022027752号")]),_vm._v(" 公司：深圳市中浩易汽车租赁有限公司")])}
var staticRenderFns = []

export { render, staticRenderFns }